<template>
    <Button
        color="carbon-400"
        :aria-label="$tr('gameContainer.fullscreen')"
        interfaceTarget="toggle-fullscreen"
        :class="$style.button_override"
        @click="emit('click')"
    >
        <Icon :name="props.isFullscreen ? 'collapse' : 'fullscreen'" />
        <Typography
            size="m"
            type="label"
            accent
            :responsive="false"
            :class="$style.button_label"
        >
            {{ $tr('gameContainer.fullscreen') }}
        </Typography>
    </Button>
</template>

<script lang="ts" setup>
import Button from '@/components/Buttons/Button.vue'
import Icon from '@/components/Icon/Icon.vue'
import Typography from '@/components/Typography.vue'

const emit = defineEmits<{
    click: []
}>()

const props = defineProps<{
    isFullscreen: boolean
}>()
</script>

<style module>
.button_override {
    padding: 8px;
}

.button_label {
    display: none;
}

@media (--desktop-large-plus) {
    .button_override {
        padding: 13px 16px;
    }
    .button_label {
        display: block;
    }
}
</style>
